export default __webpack_public_path__ + "static/media/support-any-device.87d489f8.svg";